import { useEffect, useState } from 'react';
import { SwitchPay } from '@nerdunited-switch/switchpay-components';
import { Alert, Box, styled } from '@mui/material';
// Components
import { AlertBody, LoadingSpinner } from '@/common/index';
// Hooks
import { useAuth } from '@/hooks/useAuth';
import { useCartContext } from '@/providers/CartProvider';
// Resources
import { getSwitchPaySession } from '@/resources/shopping-service.resource';

const errorObj = {
  title: 'Session Error.',
  body: 'There was an error setting the SwitchPay session. Please try again, or use External Wallet.',
};

const StyledWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
`;

const SwitchPayWrapper = ({ close, walletInfo }) => {
  const { fetcher, memberData } = useAuth();
  const { cartTotals } = useCartContext();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [switchSessionData, setSwitchSessionData] = useState(null);

  const handleGetSessionData = async () =>
    await fetcher(getSwitchPaySession(walletInfo.walletId))
      .then(setSwitchSessionData)
      .catch(handleError)
      .finally(() => setIsLoading(false));

  const handleError = () => {
    setError(true);
    setTimeout(() => close(), 3000);
  };

  useEffect(() => {
    handleGetSessionData();
  }, []);

  if (isLoading)
    return (
      <StyledWrapper>
        <LoadingSpinner type="dark" />
      </StyledWrapper>
    );

  if (error)
    return (
      <StyledWrapper>
        <Alert severity="error" variant="outlined">
          <AlertBody header={errorObj.title} body={errorObj.body}>
            <p>Returning to options...</p>
          </AlertBody>
        </Alert>
      </StyledWrapper>
    );

  return (
    <SwitchPay
      companyHeaderId={process.env.NEXT_PUBLIC_SWITCHPAY_COMPANY_HEADER_ID}
      customAmount={cartTotals?.cartSubtotal}
      environment={process.env.NEXT_PUBLIC_SWITCHPAY_ENVIRONMENT}
      handleClosingModalCallBack={close}
      handleSecurityCallback={() => switchSessionData?.client_signature}
      metadata={{
        user_email: memberData?.email,
        user_name: memberData?.fullName,
        user_phone: memberData?.phone,
      }}
      selectedWalletOptions={{
        symbol: 'ETH',
        walletAddress: walletInfo.walletId,
        network: 'mainnet',
      }}
      showModalBackOverride={true}
      userUID={switchSessionData?.user_reference}
      walletOptions={[
        {
          symbol: 'ETH',
          walletAddress: walletInfo.walletId,
          network: 'mainnet',
        },
        {
          symbol: 'USDC',
          walletAddress: walletInfo.walletId,
          network: 'mainnet',
        },
      ]}
    />
  );
};

export default SwitchPayWrapper;
